import { WebsiteConfiguration } from '@cineamo/api/models/website-configuration/WebsiteConfiguration.types';
import { WebsiteProgramListLayout } from '@cineamo/api/models/website-configuration/WebsiteProgramListLayout.enum';
import { WebsiteStyle } from '@cineamo/api/models/website-configuration/WebsiteStyle.types';

// Split out of `DefaultWebsiteConfiguration` so callers that need a complete `WebsiteStyle` to
// spread defaults from get one: `WebsiteConfiguration.style` is optional, so reading it back off
// the configuration yields `WebsiteStyle | undefined`.
export const DefaultWebsiteStyle: WebsiteStyle = {
    backgroundColor: '#451259',
    backgroundColorGradient: undefined,
    onBackgroundColor: '#F2F2F2',
    primaryColor: '#00FFDC',
    secondaryColor: '#DD82FF',
    onPrimaryColor: '#000023',
    surfaceColor: '#FFFFFF33',
    onSurfaceColor: '#F2F2F2'
};

export const DefaultWebsiteConfiguration: WebsiteConfiguration = {
    style: DefaultWebsiteStyle,
    defaultProgramAllSorting: 'showings-desc',
    defaultProgramDailySorting: 'date-asc',
    programListMobileLayout: WebsiteProgramListLayout.DEFAULT,
    programListDesktopLayout: WebsiteProgramListLayout.DEFAULT
};
